// Copyright (c) 2024 Goffy. This file belongs to Goffy. All Rights Reserved.

import type { BffWebSocketClient, LogEmitCommand } from './bffWebSocket';
import { getSharedBffWebSocket } from './bffWebSocket';
import { getClientEnvironmentDetails } from './clientEnvironment';

type LogLevel = NonNullable<LogEmitCommand['level']>;

export const createAppLogger = (
  baseHttpUrl: string,
  token?: string | null,
  defaultAttributes?: Record<string, unknown>,
  socketClient?: BffWebSocketClient | null
) => {
  const client = socketClient ?? getSharedBffWebSocket(baseHttpUrl);
  client.setAuthToken(token ?? null);

  return (message: string, attributes?: Record<string, unknown>, level: LogLevel = 'info') => {
    try {
      const envName = process.env.EXPO_PUBLIC_APP_ENV ?? process.env.NODE_ENV ?? 'unknown';
      const clientEnvironment = getClientEnvironmentDetails();
      client.setAuthToken(token ?? null);
      client.sendLog({
        message,
        level,
        attributes: { ...defaultAttributes, environment: envName, ...clientEnvironment, ...attributes },
      });
    } catch (err) {
      console.log('[appLogger][fallback]', message, attributes, err);
    }
  };
};
